import React from 'react'
import '../components/css/Services.css'
const Privacy = () => {
	return (
		<div className="privacy-sectionnn">
			<div className='container-main'>
				<div className="row">
					<div className="col-lg-12">
						<div className="privacy-section">
							<h4 className='company-name-privacy'>Haris&Co.</h4>
							<h5 className='company-name-privacy-txt'>Privacy Policy</h5>
							<p>Last updated 2024.							</p>
							<p>This Privacy Policy applies to Haris&Co. (“us”, “we”, or “our”) and how we use and protect the data the user (“you” or “your”) provides to us when you visit and use harisandco.</p>
							<p>We reserve the right to change this policy at any given time, of which you will be promptly updated. If you want to make sure that you are up to date with the latest changes, we advise you to frequently visit this page.							</p>
							<p>Haris&Co. r​ecognises the importance of maintaining your privacy. We value your privacy and appreciate your trust in us. This Policy describes how we treat user information we collect on harisandco and other offline sources. This Privacy Policy applies to current and former visitors to our website and to our online customers. By visiting and/or using our website, you agree to this Privacy Policy.</p>
						<h5 className='bld'>User Data We Collect</h5>
						<p>When you visit our site, we may collect the following data,</p>
						<ul>
							<li>Your IP address.</li>
							<li>Your contact information and email address.</li>
							<li>Other information such as interests and preferences.</li>
							<li>Other information such as interests and preferences.Data profile regarding your online behaviour on our blog.</li>
						</ul>
						<h5 className='bld'>Why We Collect User Data</h5>
						<p>We may collect your data for the following reasons:</p>
						<ul>
							<li>To better understand your needs.							</li>
							<li>To improve our services and products.							</li>
							<li>To send you promotional emails containing the information we think you will find interesting.							</li>
							<li>To contact you to fill out surveys and participate in other types of market
							research.</li>
							<li>To customise our website according to your online behaviour and personal
							preferences.</li>
						</ul>
						
						<h5 className='bld'>Safeguarding & Securing the Data </h5>
						
						<p>Haris&Co. is committed to securing your data and keeping it confidential. </p>
						<p>Haris&Co. has done all in its power to prevent data theft, unauthorised access, and disclosure by implementing the latest technologies and software, which help us safeguard all the information we collect online.</p>
						
						<h5 className='bld'>Our Cookie Policy</h5>
						<p>Once you agree to allow our website to use cookies, you also agree to use the data it collects regarding your online behaviour (analyse web traffic, web pages you visit and spend the most time on).
						</p>
						<p>The data we collect by using cookies is used to customise our blog to your needs. After we use the data for statistical analysis, the data is completely removed from our systems.</p>
						<p>Please note that cookies don't allow us to gain control of your computer in any way. They are strictly used to monitor which pages you find useful and which you do not so that we can provide a better experience for you.	</p>
						<p>If you want to disable cookies, you can do it by accessing the settings of your internet browser. You can visit https://www.internetcookies.com, which contains comprehensive information on how to do this on a wide variety of browsers and devices.</p>
					
					
					
					
					
						<h5 className='bld'>Links to Other Websites</h5>
						<p>Our blog contains links that lead to other websites. If you click on these links Haris&Co.  is not held responsible for your data and privacy protection. Visiting those websites is not governed by this privacy policy agreement. Make sure to read the privacy policy documentation of the website you go to from our website.</p>
					
					
					
						<h5 className='bld'>Restricting the Collection of your Personal Data</h5>
						<p>At some point, you might wish to restrict the use and collection of your personal data. You can achieve this by doing the following:</p>
						<p>When you are filling the forms on the website, make sure to check if there is a box which you can leave unchecked, if you don't want to disclose your personal information.</p>
						<p>If you have already agreed to share your information with us, feel free to contact us via email and we will be more than happy to change this for you.</p>
					
						<p>Haris&Co. will not lease, sell or distribute your personal information to any third parties, unless we have your permission. We might do so if the law forces us. Your personal information will be used when we need to send you promotional materials if you agree to this privacy policy.</p>
					
					
					
					
					
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Privacy